export default class CardComponentType {
    public static HorizontalBarMeterEndStart: number = 0;
    public static HorizontalBarMeterMiddleStart: number = 1
    public static NumberComparisonTable: number = 2;
    public static GaugeChart: number = 3;
    public static PlayerBreakdownTable: number = 4;
    public static TeamBreakdownTable: number = 5;
    public static StandardValueDisplay: number = 6;
}